import { MemberListReport } from "../../components/report";

export default function MemberListLive() {
  return <MemberListReport variant="live" />;
}
